import { createAction, props } from '@ngrx/store';
import { HelocApplicationRequest, HelocApplicationResponse, HelocApplicationsPage } from '../../models/heloc.model';

export const submitHelocApplication = createAction(
  '[HELOC] Submit Application',
  props<{ data: HelocApplicationRequest }>()
);

export const submitHelocApplicationSuccess = createAction(
  '[HELOC] Submit Application Success',
  props<{ application: HelocApplicationResponse }>()
);

export const submitHelocApplicationFailure = createAction(
  '[HELOC] Submit Application Failure',
  props<{ error: string }>()
);

export const getHelocApplications = createAction(
  '[HELOC] Get Applications',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const getHelocApplicationsSuccess = createAction(
  '[HELOC] Get Applications Success',
  props<{ page: HelocApplicationsPage }>()
);

export const getHelocApplicationsFailure = createAction(
  '[HELOC] Get Applications Failure',
  props<{ error: string }>()
);

export const getHelocApplicationById = createAction(
  '[HELOC] Get Application By Id',
  props<{ id: number }>()
);

export const getHelocApplicationByIdSuccess = createAction(
  '[HELOC] Get Application By Id Success',
  props<{ application: HelocApplicationResponse }>()
);

export const getHelocApplicationByIdFailure = createAction(
  '[HELOC] Get Application By Id Failure',
  props<{ error: string }>()
);

export const resetHelocState = createAction('[HELOC] Reset State');
